import { render, staticRenderFns } from "./check-user-change.vue?vue&type=template&id=a4460dd6"
import script from "./check-user-change.vue?vue&type=script&lang=ts"
export * from "./check-user-change.vue?vue&type=script&lang=ts"
import style0 from "./check-user-change.vue?vue&type=style&index=0&id=a4460dd6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports